import Image from "components/Image"
import DynamicComponent from ".."
import PatternedDiv from "components/PatternedDiv"
import Link from "next/link"
import CallToAction from "components/CallToAction"
import { getStoryblokLink } from "utilities/getStoryblokLink"
import FormSection from "components/FormSection"

export default function ContactPage({ story }) {
  return (
    <main className="page-content">
      {story?.page?.content?.blocks.map((blok) => (
        <DynamicComponent blok={blok} key={blok._uid} />
      ))}

      <section className=" bg-warm-white pt-12 lg:pt-16">
        <PatternedDiv
          eyebrow={story?.page?.content?.offices_eyebrow}
          heading={story?.page?.content?.offices_heading}
          heading2={story?.page?.content?.offices_heading2}
        >
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 pt-8relative">
            {story?.offices?.items.map((office) => (
              <Link
                href={`/${office.full_slug}`}
                className="group relative z-10 bg-white rounded-4xl overflow-hidden shadow-lg flex flex-col cursor-pointer  hover:scale-105 transition-transform "
                key={`office-${office.uuid}`}
              >
                <div className="relative bg-white h-36">
                  {office.content?.photo?.filename && (
                    <Image
                      placeholder={office.content.photo?.blurDataURL ? "blur" : "empty"}
                      blurDataURL={office.content.photo?.blurDataURL}
                      alt={office.content.photo.alt}
                      src={office.content.photo.filename}
                      fill
                      sizes="(min-width: 1240px) 392px, (min-width: 1024px) 360px, (min-width: 640px) 448px, (min-width: 520px) 543px, 423px"
                      className="object-cover"
                    />
                  )}
                </div>
                <div className="p-6 flex flex-col flex-1 justify-between group-hover:bg-blue ">
                  <div>
                    <h3 className="text-m3 uppercase tracking-wider text-blue group-hover:text-white">
                      {office.content?.name}
                    </h3>
                  </div>
                </div>
              </Link>
            ))}
          </div>
          <div className="pt-16 2xl:pt-24 text-center">
            <h2 className="font-bold text-blue mb-2">{story?.page?.content?.cta_heading}</h2>
            <CallToAction style="secondary-light" href={getStoryblokLink(story?.page?.content?.cta_link)}>
              {story?.page?.content?.cta_link_text}
            </CallToAction>
          </div>
        </PatternedDiv>
      </section>
      <FormSection eyebrow="Connect With Us" heading="This Could Be The Start of a" heading2="Great Relationship." />
    </main>
  )
}
